import React, { useEffect } from "react";
import Header from "../../../components/header";
import "./energypage.css";
import HomeVideo from "../../../assets/energy_background-2.png";
import FlipCard from "./FlipCard";
import { ParallaxProvider } from "react-scroll-parallax";
import OtherEnergyTargetsCharts from "./OtherEnergyTargetsCharts";
import EnergyReport from "./energy_report";
import NumberCard from "./numbercard";
import EnergyCharts2 from "./EnergyCharts_2"
import GreenParagraph from "./greenParagraph";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

export default function Homepage() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("energy");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        {/* home video */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
              {/* <video
              autoPlay
              loop
              muted
              className="home-video"
              style={{ height: "100vh", width: "100%", objectFit: "cover" }}
            >
              <source src={HomeVideo} type="video/mp4" />
            </video> */}
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="energy-video-text-box">
              <div className="video-background-text">
                <Parallax speed={10}>
                  <h1 className="energy-topic-home">ENERGY</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                  {/* Conserve <br /> */}
                  <span className="white-box-container-h1">Energy</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                {/* Conserve <br /> */}
                  <span className="white-box-container-h1">
                    Energy <br />
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>
          
        </div>

        {/* section-2 */}
        <div className="energy-cards">
          <div className="energy-para-box">
            <div data-aos="zoom-in">
              <h1 className="energy-para-two" id="energy">ENERGY</h1>
            </div>
            <div data-aos="fade-left">
              <center>
                <div className="energy-card-width">
                  <NumberCard />
                </div>
              </center>
            </div>
          </div>
        </div>

        {/* section-3 */}
        <GreenParagraph />

        {/* section-4 */}
        <OtherEnergyTargetsCharts />

        {/* section-5 */}
        <EnergyReport />

        {/* section-6 */}
        <EnergyCharts2 />

        {/* section-7 */}
        <FlipCard />
      </div>
    </ParallaxProvider>
  );
}
